import styled from "styled-components";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import {JACKPOT_STATE} from '../../../../../../../common/const/jackpot_map_ids';
import { JackpotThemeType } from "../../../../../../services/jackpots/jackpots.service.interface";
import {JACKPOT_WIDGET_LAYOUT} from "../../../../jackpot-widget.component";

interface IJackpotWidgetClockLabelBox{
    state: JACKPOT_STATE;
    layout: JACKPOT_WIDGET_LAYOUT;
    widgetWidth: number;
    themeType: JackpotThemeType;
}

const handleClockLabelFontSize = (layout: JACKPOT_WIDGET_LAYOUT, widgetWidth: number) => {
    switch (layout) {
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
            /** In landscape view at a widget width of 468px, the amount should be of font-size 14px */
            return widgetWidth * 14 / 468 + "px";
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
            /** In minimized view at a widget width of 375px, the amount should be of font-size 9px */
            return widgetWidth * 9 / 375 + "px";
        case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
        default:
            /** In portrait view at a widget width of 131px, the amount should be of font-size 9px */
            return widgetWidth * 9 / 131 + "px";
    }
};

const JackpotWidgetClockLabelDefaultBox = styled.div<IJackpotWidgetClockLabelBox>`
    ${({theme}) => theme.font.presets.body};
    text-transform: uppercase;
    color: ${({state, theme}) => state === JACKPOT_STATE.Hot ? theme.colors.brandSecondary : theme.colors.textLight };
    letter-spacing: 0.02rem;

    width: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "74%" : "100%" };
    text-align: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "left" : "center" };
    font-size: ${({widgetWidth, layout}) => handleClockLabelFontSize(layout, widgetWidth)};
`;

const JackpotWidgetClockLabelCasino777Box = styled(JackpotWidgetClockLabelDefaultBox)`
    color: ${({state, theme, themeType}) => themeType === JackpotThemeType.Light ? (state === JACKPOT_STATE.Hot ? theme.colors.danger : theme.colors.textContrast) : theme.colors.brandSecondary};
`;

const JackpotWidgetClockLabelSiBox = styled(JackpotWidgetClockLabelDefaultBox)`
    color: ${({theme}) => theme.colors.textContrast };
`;

const JackpotWidgetClockLabelMrGreenBox = styled(JackpotWidgetClockLabelDefaultBox)`
    color: ${({theme}) => theme.colors.textDark };
`;

export const JackpotWidgetClockLabelBox = styledByTheme(JackpotWidgetClockLabelDefaultBox)
    .forCasino777(JackpotWidgetClockLabelCasino777Box)
    .forSI(JackpotWidgetClockLabelSiBox)
    .forSICis(JackpotWidgetClockLabelSiBox)
    .forMrGreen(JackpotWidgetClockLabelMrGreenBox)
    .forMrGreenCis(JackpotWidgetClockLabelMrGreenBox)
    .apply();
